import React, { useRef } from 'react';
import { useScrollProgress } from '../../hooks/useScrollProgress';

const STATEMENT = 'Architecture, security and cost get decided together, by the people who will write the code.';

const STEPS = [
  { title: 'Consult', text: 'Thirty minutes on risks, architecture options and a rough delivery plan.' },
  { title: 'Prototype', text: 'You click through the UI and UX before we commit to building it.' },
  { title: 'Build', text: 'Founders lead the delivery, and you have direct access to the builders.' },
  { title: 'Test', text: 'Thorough testing before release, with security checked alongside features.' },
  { title: 'Support', text: 'We stay after launch, and we come on site when that is what it takes.' },
];

const About = () => {
  const statementRef = useRef(null);
  useScrollProgress(statementRef, { mode: 'through' });
  const words = STATEMENT.split(' ');

  return (
    <section id="about" className="about" aria-labelledby="about-title">
      <h2 id="about-title" className="about-title" ref={statementRef} aria-label={STATEMENT} style={{ '--n': words.length }}>
        {words.map((word, index) => (
          <span key={`${word}-${index}`} aria-hidden="true" style={{ '--i': index }}>{word} </span>
        ))}
      </h2>

      <div className="about-body">
        <p>
          Recent work from our engineers includes marketplaces, fintech workflows and e-commerce platforms.
          We're a hands-on team, and we're now taking on select new builds.
        </p>
      </div>

      <ol className="steps">
        {STEPS.map((step, index) => (
          <li key={step.title}>
            <span className="step-number" aria-hidden="true">{index + 1}</span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default About;
